var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.016 10.2021C17.776 10.2021 20.016 7.96215 20.016 5.20215C20.016 2.44215 17.776 0.202148 15.016 0.202148C12.256 0.202148 10.016 2.44215 10.016 5.20215C10.016 7.96215 12.256 10.2021 15.016 10.2021ZM20.466 15.8021C20.076 15.4021 19.586 15.2021 19.016 15.2021H12.016L9.936 14.4721L10.266 13.5321L12.016 14.2021H14.816C15.166 14.2021 15.446 14.0621 15.676 13.8321C15.906 13.6021 16.016 13.3221 16.016 13.0121C16.016 12.4721 15.756 12.1021 15.236 11.8921L7.966 9.20215H6.016V18.2021L13.016 20.2021L21.046 17.2021C21.056 16.6721 20.856 16.2021 20.466 15.8021ZM4.016 9.20215H0V20.2021H4.016V9.20215Z",
    fill: "#F7A600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharity);
export default __webpack_public_path__ + "static/media/charity.b9dfe16b7dd74586c07561d79a20f3da.svg";
export { ForwardRef as ReactComponent };